import { List, ListItem } from '@mui/material';
import { Button, Link, Typography } from '@nutrien/ddc-components';
import { EventDetails, sendServiceWorkerMessage } from '@nutrien/ddc-fe-logging-pwa';
import { loggingContext, LogLevel } from '@nutrien/ddc-fe-logging-react-router-dom';
import { generateGuid } from '@nutrien/ddc-fe-util';
import { useContext, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const Home = () => {
  const { levelEventLogger, errorLogger } = useContext(loggingContext);
  useEffect(() => levelEventLogger(LogLevel.info, 'Home:mount'), [levelEventLogger]);

  function logClicked() {
    levelEventLogger(LogLevel.info, 'Home:log:clicked');
  }

  function serviceWorkerLogClicked() {
    const id = generateGuid();
    levelEventLogger(LogLevel.info, 'Requesting service worker to log', { id });
    sendServiceWorkerMessage<EventDetails>(navigator, {
      id,
      message: 'Client is requesting service worker log this',
    }).catch(error => {
      errorLogger(error, { message: 'Error messageing service worker', id });
    });
  }

  return (
    <>
      <Typography variant="headline1">PWA Home</Typography>
      <List>
        <ListItem>
          <Link component={RouterLink} to="/one">
            One
          </Link>
        </ListItem>
        <ListItem>
          <Link component={RouterLink} to="/two">
            Two
          </Link>
        </ListItem>
        <ListItem>
          <Button onClick={() => logClicked()}>Log Something</Button>
        </ListItem>
        <ListItem>
          <Button onClick={() => serviceWorkerLogClicked()}>
            Tell Service Worker to Log Something
          </Button>
        </ListItem>
      </List>
    </>
  );
};

export default Home;
